import React from 'react';
import {
  HeaderLayout,
  HeaderTextLayout,
  HeaderText,
  SubheaderText,
  TextLink,
} from './TaskManager.styles';
import env from 'bench-environment';
import { Person } from './types';

const Header = ({
  loggedInPerson,
  isBpaView = false,
}: {
  loggedInPerson: Person;
  isBpaView?: boolean;
}) => {
  return (
    <HeaderLayout role="heading">
      <HeaderTextLayout>
        <HeaderText>{isBpaView ? 'My Tasks' : 'Task Manager'}</HeaderText>
        <SubheaderText>{loggedInPerson?.fullName}</SubheaderText>
      </HeaderTextLayout>
      <TextLink href={env.location.dashboard}>Go to FLO</TextLink>
    </HeaderLayout>
  );
};

export default Header;
